import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { tokens } from "../theme";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

const ViewOrdersModal = ({
  setOpenModal,
  data,
}: {
  setOpenModal: React.Dispatch<
    React.SetStateAction<{
      showModal: boolean;
      products: never[];
    }>
  >;
  data: any[];
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const columns = [
    { field: "_id", headerName: "ID", width: 190 },
    {
      field: "title",
      headerName: "Product Name",
      width: 150,
    },
    {
      field: "description",
      headerName: "Descriptioni",
      width: 190,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      width: 200,
    },
    {
      field: "price",
      headerName: "Price",
      width: 200,
    },
  ];

  return (
    <div className=" flex flex-col justify-center items-center fixed left-0 top-0 right-0 bottom-0 bg-[rgba(0,0,0,0.5)] z-[3]">
      <div className="max-w-[1000px] w-[-webkit-fill-available] p-[10px] bg-[#fff] border-[#eee]">
        <div className="p-[10px] flex justify-between">
          <Typography variant="h3" color={colors.blueAccent[400]}>
            Add Landing Page
          </Typography>
          <div
            className="text-lg select-none hover:cursor-pointer"
            onClick={() => setOpenModal({ showModal: false, products: [] })}
          >
            X
          </div>
        </div>
        <div className="p-[10px]">
          <Box
            m={"40px 0 0 0"}
            height="75vh"
            width="100%"
            sx={{
              "& .MuiDataGrid-root": {
                border: "none",
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "none",
              },
              "& .name-column--cell": {
                color: colors.greenAccent[300],
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: colors.blueAccent[700],
                borderBottom: "none",
              },
              "& .MuiDataGrid-virtualScroller": {
                backgroundColor: colors.primary[400],
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "noone",
                backgroundColor: colors.blueAccent[700],
              },
              "& .MuiCheckbox-root": {
                color: `${colors.greenAccent[200]} !important`,
              },
              "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                color: `${colors.grey[100]} !important`,
              },
            }}
          >
            <DataGrid
              components={{ Toolbar: GridToolbar }}
              rows={data}
              /*@ts-ignore */
              columns={columns}
              autoHeight={true}
              getRowId={(row) => row._id}
            />
          </Box>
        </div>
      </div>
    </div>
  );
};

export default ViewOrdersModal;
